/*globals $*/
'use strict';

const getValidationFunctions = () => import("./validate");

$( document ).ready(function() {

    $('[id^="checkPost"]').on('click', function(e){
        $('#status').val($(this).attr('data-type'));

        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validatePostForm();
        });
    });

    $('[id^="checkWarning"]').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateWarningForm();
        });
    });

    $('[id^="checkEvent"]').on('click', function(e){
        $('#status').val($(this).attr('data-type'));

        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateEventForm();
        });
    });

    $('#checkMember').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateMemberForm();
        });
    });

    $('#saveSingleOrganization').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateOrganizationForm();
        });
    });

    $('#checkAccess').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateAccessForm();
        });
    });

    $('[id^="checkPopup"]').on('click', function(e){
        $('#status').val($(this).attr('data-type'));

        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validatePopupForm();
        });
    });

    $('#checkTenders').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateTendersForm();
        });
    });

    $('#checkGroup').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateGroupForm();
        });
    });

    $('#addBoardDirectors').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateBoardForm();
        });
    });

    $('#addOtherAddress').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateAddressForm();
        });
    });

    $('#checkSeo').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateSeoForm();
        });
    });

    $('[id^="checkFile"]').on('click', function(e){
        $('#status').val($(this).attr('data-type'));

        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateFileForm();
        });
    });

    $('[id^="checkVideo"]').on('click', function(e){
        $('#status').val($(this).attr('data-type'));

        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateVideoForm();
        });
    });

    $('[id^="checkProject"]').on('click', function(e){
        $('#status').val($(this).attr('data-type'));

        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateProjectForm();
        });
    });

    $('#addUser').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateOtherUserForm();
        });
    });
});

